module.exports = __webpack_public_path__ + "static/media/print-search.15919d85.svg";